import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button, Modal, Form, Input, Row, Col } from 'antd';
import { PlusOutlined, ReloadOutlined, EditOutlined } from '@ant-design/icons';
import PurOrdDivisionActions from '../../Stores/PurOrdDivision/Actions';

const PurOrdDivision = () => {
  const dispatch = useDispatch();
  const { data } = useSelector(state => state.purOrdDivision);
  const { curDivisionId } = useSelector(state => state.app);

  // CPS03 fixed division destinations
  // const [destinations, setDestinations] = useState([
  //   { id: 1, division: 'CPS03', code: 'WHA', location: 'Warehouse A' },
  //   { id: 2, division: 'CPS03', code: 'PKG', location: 'Port Klang' },
  //   { id: 3, division: 'CPS03', code: 'WHB', location: 'Warehouse B' },
  //   { id: 4, division: 'CPS03', code: 'JHB', location: 'Johor Hub' }
  // ]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingDestination, setEditingDestination] = useState(null);
  const [form] = Form.useForm();

  const showModal = (destination = null) => {
    setEditingDestination(destination);
    if (destination) {
      form.setFieldsValue(destination);
    } else {
      form.resetFields();
    }
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        if (editingDestination) {
          // Edit existing destination
          dispatch(
            PurOrdDivisionActions.purOrdDivisionUpdateDivisionMap(editingDestination.id, values)
          );
        } else {
          // Add new destination (always with CPS03 division)
          dispatch(PurOrdDivisionActions.purOrdDivisionCreateDivisionMap(values));
        }
        setIsModalVisible(false);
      })
      .catch(info => console.log('Validate Failed:', info));
  };

  const handleCancel = () => setIsModalVisible(false);

  const columns = [
    { title: 'Division', dataIndex: 'fr_division_code', key: 'fr_division_code' },
    { title: 'Destination Code', dataIndex: 'division_code', key: 'division_code' },
    { title: 'Location', dataIndex: 'location_code', key: 'location_code' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button icon={<EditOutlined />} onClick={() => showModal(record)}>
          Edit
        </Button>
      )
    }
  ];

  useEffect(() => {
    dispatch(PurOrdDivisionActions.purOrdDivisionFetchList());
  }, [dispatch, curDivisionId]);

  return (
    <>
      <Table
        title={() => (
          <Row gutter={8}>
            <Col>
              <Button icon={<ReloadOutlined />} onClick={() => console.log('Reload clicked')} />
            </Col>
            <Col>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal()}>
                New Destination
              </Button>
            </Col>
          </Row>
        )}
        columns={columns}
        dataSource={data && data.pur_odr_division_to ? data.pur_odr_division_to : []}
        rowKey="id"
        pagination={false}
      />

      <Modal
        title={editingDestination ? 'Edit Destination' : 'Add New Destination'}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="division_code"
            label="Destination Code"
            rules={[{ required: true, message: 'Please enter destination code' }]}
          >
            <Input placeholder="Enter destination code" />
          </Form.Item>
          <Form.Item
            name="location_code"
            label="Location"
            rules={[{ required: true, message: 'Please enter location name' }]}
          >
            <Input placeholder="Enter location" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default PurOrdDivision;
